export default __webpack_public_path__ + "designsystem/assets/images/_global/watermarks/_gov-blue.svg";